export default __webpack_public_path__ + "static/media/About_Landing-14.bebb39e8.png";